__turbopack_context__.v({
  "body": "theme-modal-module__XsC9dG__body",
  "close": "theme-modal-module__XsC9dG__close",
  "content": "theme-modal-module__XsC9dG__content",
  "header": "theme-modal-module__XsC9dG__header",
  "overlay": "theme-modal-module__XsC9dG__overlay",
  "title": "theme-modal-module__XsC9dG__title",
});
